import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TabViewModule } from 'primeng/tabview';
import { catchError, throwError } from 'rxjs';
import { HttpResponse } from '../../../model/HttpResponse';
import { QueryOptionDto } from '../../../model/QueryOptionDto';
import { AcademyAdministratorOperation } from '../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../model/administrator/AdministratorEntity';
import { Category } from '../../../model/competitions/Category';
import { Competition } from '../../../model/competitions/Competition';
import { CategoryLevel } from '../../../model/competitions/Level';
import { Registration } from '../../../model/competitions/Registration';
import { RegistrationStatus } from '../../../model/enum/RegistrationStatus';
import { CompetitionService } from '../../../services/competition.service';
import { LoadingService } from '../../../services/loading.service';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';
import { CrudTableComponent } from '../../shared/tables/crud-table/crud-table.component';
import { AdvancedRegistrationsComponent } from "./advanced-registrations/advanced-registrations.component";
import { FinancialReportComponent } from "./financial-report/financial-report.component";
import { RegistrationsTableComponent } from "./registrations-table/registrations-table.component";


@Component({
    selector: 'app-competition-detail',
    standalone: true,
    providers: [MessageService],
    templateUrl: './competition-detail.component.html',
    styleUrl: './competition-detail.component.scss',
    imports: [InputTextareaModule,
        CalendarModule,
        InputMaskModule,
        SelectButtonModule,
        InputSwitchModule,
        InputTextModule,
        PageHeaderComponent,
        CrudTableComponent,
        ConfirmDialogModule,
        CommonModule,
        DialogModule,
        ReactiveFormsModule,
        MultiSelectModule,
        InputNumberModule,
        FloatLabelModule,
        TabViewModule, RegistrationsTableComponent, FinancialReportComponent, AdvancedRegistrationsComponent]
})
export class CompetitionDetailComponent implements OnInit {
  showForm: boolean = false;
  
  @Input() 
  competition!: Competition;
  
  @Input()
  categories: Category[] = [];

  @Input()
  Levels: CategoryLevel[] = [];


  @Output()
  onFormClosed: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  /** Inscripciones exitosas (REGISTERED), usadas por la inscripción general y el resumen financiero */
  registrations:Registration[] = [];
  /** Inscripciones en todos los estados (REGISTERED, PRE_REGISTERED, NOT_REGISTERED), usadas por la vista avanzada */
  allRegistrations:Registration[] = [];
  showRegistrations:boolean = false;

  activeTabIndex:number = 0;
  showMembersRegisters:boolean = false;
  showAdvancedRegisters:boolean = false;
  showClubesRegisters:boolean = false;
  showFinancialResumen:boolean = false;
  constructor(private competitionService:CompetitionService,private loadingService:LoadingService, private messageService:MessageService) { }

  ngOnInit(): void {
    this.getCompetitionRegistations();
  }

  onTabChange(event:any){
    this.activeTabIndex = event.index;
    this.showMembersRegisters = this.activeTabIndex === 0;
    this.showAdvancedRegisters = this.activeTabIndex === 1;
    this.showClubesRegisters = this.activeTabIndex === 2;
    this.showFinancialResumen = this.activeTabIndex === 3;
  }

  /**
   * Recalcula las inscripciones exitosas a partir de las inscripciones completas.
   * Se ejecuta al cargar y cada vez que la vista avanzada edita o elimina registros,
   * para que la inscripción general y el resumen financiero queden sincronizados.
   */
  refreshRegistrationsDerived() {
    this.registrations = this.allRegistrations.filter(
      (registration) =>
        registration.status === RegistrationStatus.REGISTERED &&
        registration.isActive !== false
    );
  }

  getCompetitionRegistations() {
      this.loadingService.showLoading();
      // Se consultan las inscripciones en todos sus estados para habilitar la vista
      // avanzada; las demás pestañas siguen trabajando solo con las exitosas (REGISTERED).
      const options: QueryOptionDto = {
        options: {
          conditionals: [
            {
              conditionalConnector: 'AND',
              logicOperator: '=',
              evaluatedProperty: 'competitionId',
              parameterName: '@CompetitionId',
              parameterValue: this.competition.id,
            },
          ],
        },
      };
  
      const entity: AdministratorEntity = {
        type: AcademyAdministratorType.REGISTRATIONS,
        operation: AcademyAdministratorOperation.SELECT,
        payload: options,
      };
  
      this.competitionService
        .sendRequest(entity)
        .pipe(catchError(this.handleError.bind(this)))
        .subscribe((response: HttpResponse) => {
          if (response.code === 200 && response.response) {
            this.allRegistrations = response.response as Registration[];
            this.refreshRegistrationsDerived();
            this.showForm = true;
            this.showMembersRegisters = true;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Sin evento',
              detail: 'No se encontraron eventos para la modalidad seleccionada',
              life: 5000,
            });
          }
          this.loadingService.hideLoading();
        });

  }

  
  
  handleError(error: HttpErrorResponse) {
    this.loadingService.hideLoading();
    if (error.status === 422) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin resultados',
        detail: 'No se encontraron resultados para la búsqueda realizada',
        life: 5000,
      });
    } else if (error.status === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'No se pudo establecer conexión con el servidor, por favor inténtalo nuevamente',
        life: 5000,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error.message,
        life: 5000,
      });
    }
    // Return an observable with a user-facing error message.
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }

  closeDialog() {
    this.showForm = false;
    this.onFormClosed.emit(false);
  }


}
